import { PublicResource, Related } from '../../resource-types';
import { RawModel } from '../schema';

export type ContractType = PublicResource & {
  relationships: {
    contract_key_groups: Related<'contract-key-group'>[];
  };
};

export const contractType: RawModel = {
  type: 'contract-type',
  plural: 'contract-types',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    display_name: 'string'
  },
  relationships: {}
};
